<template>
  <div class="wrap">
    <div class="left"></div>
    <div class="right">
      <div class="loginBox">
        <div class="logo"><img src="@/assets/image/logo.png" alt=""></div>
        <div class="username">
          <div class="int">
            <el-input v-model="form.email" placeholder="请输入电子邮箱" clearable></el-input>
          </div>
          <div v-if="errors.email" class="error-text">{{ errors.email }}</div>
        </div>
        <div class="username">
          <div class="int">
            <el-input v-model="form.password" placeholder="请输入密码"></el-input>
          </div>
          <div v-if="errors.password" class="error-text">{{ errors.password }}</div>
        </div>
        <div class="username">
          <div class="int">
            <el-input v-model="form.confirmPassword" placeholder="请再次输入密码" show-password clearable
              @blur="validateConfirmPassword"></el-input>
          </div>
          <div v-if="errors.confirmPassword" class="error-text">{{ errors.confirmPassword }}</div>
        </div>
        <!--        <div class="btnbox">
          <div>
            <el-tooltip :class="!isCompany?'buttint':'buttints'" effect="light" content="个人:指个人或团队参赛的一般选手" placement="bottom">
              <el-button>个人<i class="el-icon-warning-outline" style="margin-left: 8px"></i></el-button>
            </el-tooltip>
          </div>
          <div><el-button :class="isCompany?'buttint':'buttints'">企业</el-button></div>
        </div> -->
        <div class="btn">
          <el-button class="buttint" :loading="loading" @click="handleRegister">注册</el-button>
        </div>
        <div class="check">
          <div><el-checkbox v-model="checked">已阅读，并同意 鹏海科技《用户协议》</el-checkbox>
            <div v-if="errors.agreed" class="error-text">{{ errors.agreed }}</div>
          </div>
        </div>

        <div class="register">
          <div class="line"></div>
          <div class="name" @click="goLogin">已有账号,立即登录</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    register
  } from '@/api/user'
  // import {
  //   encrypt
  // } from '@/utils/jsencrypt'

  export default {
    name: "register",
    data() {
      return {
        form: {
          email: "",
          password: "",
          confirmPassword: "",
        },
        agreed: false,
        errors: {
          email: "",
          password: "",
          confirmPassword: "",
          agreed: ""
        },
        isCompany: false,
        loading: false
      }
    },
    methods: {
      goLogin() {
        this.$router.push("/Login")
      },

      validateConfirmPassword() {
        if (this.form.password !== this.form.confirmPassword) {
          this.errors.confirmPassword = "两次输入的密码不一致"
        } else {
          this.errors.confirmPassword = ""
        }
      },

      validateForm() {
        let isValid = true

        if (!this.form.email) {
          this.errors.email = "请输入邮箱"
          isValid = false
        } else if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.form.email)) {
          this.errors.email = "邮箱格式不正确"
          isValid = false
        } else {
          this.errors.email = ""
        }

        if (!this.form.password) {
          this.errors.password = "请输入密码"
          isValid = false
        } else if (this.form.password.length < 6) {
          this.errors.password = "密码长度不能少于6位"
          isValid = false
        } else {
          this.errors.password = ""
        }

        this.validateConfirmPassword()
        if (this.errors.confirmPassword) {
          isValid = false
        }


        return isValid
      },

      async handleRegister() {
        // 检查用户协议
        if (!this.checked) {
          this.errors.agreed = "请阅读并同意用户协议"
          return
        } else {
          this.errors.agreed = ""
        }
        // this.loading = true;

        if (!this.validateForm()) {
          return;
        }

        this.loading = true

        try {
          const registerData = {
            email: this.form.email,
            password: this.form.password
          }

          console.log("发送注册数据:", JSON.stringify(registerData))

          const response = await register(registerData)
          console.log("注册响应:", response)

          if (response && (response.code === 200 || response.code === '200')) {
            this.$message.success(response.msg || "注册成功")
            this.$router.push("/login")
          } else {
            const errorMsg = response ?
              (response.msg || `注册失败，错误码: ${response.code}`) :
              "注册失败，无响应数据"
            this.$message.error(errorMsg)
          }
        } catch (error) {
          console.error("完整错误对象:", error)
          if (error.code === 'ECONNABORTED') {
            this.$message.error("请求超时，请检查网络连接")
          } else if (error.response) {
            // 处理HTTP错误响应
            const res = error.response
            let errorMsg = res.data ?
              (res.data.msg || `服务器错误: ${res.status}`) :
              `请求失败: ${res.status}`
            this.$message.error(errorMsg)
          } else if (error.request) {
            this.$message.error("网络错误，请求未发出")
          } else {
            this.$message.error("发生未知错误: " + error.message)
          }
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .error-text {
    color: red;
  }

  .wrap {
    width: 100%;
    display: flex;

    .left {
      width: 60%;
      height: 100vh;
      background: url('../../assets/image/leftImg.png') no-repeat;
      background-position: center;
      background-size: cover;
    }

    .right {
      width: 40%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;

      .loginBox {
        width: 40%;
        height: 50vh;

        .logo {
          width: 100%;
          padding: 30px 0;
          display: flex;
          justify-content: center;
        }

        .username {
          text-align: left;
          width: 100%;

          .name {
            font-weight: bold;
          }

          .nameEnglish {
            padding-left: 20px;
            font-size: 14px;
          }

          .int {
            padding: 10px 0;
          }
        }

        .btnbox {
          width: 100%;
          display: flex;
          justify-content: space-between;

          div {
            width: 48%;

            .buttint {
              width: 100%;
              background-color: #25877d;
              color: #ffffff;
            }

            .buttints {
              width: 100%;
            }

            .buttints:hover {
              background-color: #ffffff;
              border: 1px solid #C0C0C0;
              color: #000000;
            }
          }
        }

        .btn {
          width: 100%;
          padding: 30px 0;

          .buttint {
            width: 100%;
            background-color: #25877d;
            color: #ffffff;
          }
        }

        .check {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }

        .register {
          width: 100%;
          height: 60px;
          align-items: center;
          display: flex;

          .line {
            width: 25%;
            height: 6px;
            background-color: #25877d;
          }

          .name {
            width: 50%;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Login/register.vue